import { mdiPrinterOutline } from '@mdi/js';
import Icon from 'components/Icon/Icon';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';
import ReactToPrint from 'react-to-print';

import Button from './Button';

interface Props {
  content: React.MutableRefObject<HTMLDivElement | null>;
}

const PrintButton: React.FC<Props> = (props): React.ReactElement => {
  const { t } = useCustomTranslation();

  return (
    <ReactToPrint
      content={() => props.content.current}
      trigger={() => (
        <Button type="primary" icon={<Icon path={mdiPrinterOutline} />}>
          {t('common.print')}
        </Button>
      )}
    />
  );
};

export default PrintButton;
